/** Compatibility export; the headless package owns this contract. */
export * from '@galapagos/catalog-schema/components/CheckboxField/CheckboxField';
